import { render, staticRenderFns } from "./advertisement_video_list.vue?vue&type=template&id=05697b4f"
import script from "./advertisement_video_list.vue?vue&type=script&lang=js"
export * from "./advertisement_video_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports